<template>
  <div class="specialBetsForm">
    <div class="bet-name">{{ this.name }}</div>
    <input
      v-for="(bet, index) in specialBet.inputs"
      :key="index"
      :data-index="`${index}`"
      v-model="bettingSvc.ticket.input[index]"
      @keydown="updated"
      autocomplete="off"
      @click="setFocus(index)"
      type="number"
      :disabled="isBettingDisabled"
    >
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { EventBus } from '../../../utilities/event.bus';
import { GameSvc } from '../../../services/game.service';
import { BettingSvc } from '../../../services/betting.service';
import { GatewaySvc } from '../../../services/gateway.service';
import { invalidChars } from '../../../utilities/invalidCharsChecker';

export default {
  props: {
    name: {},
    trigger: {},
    actions: {
      type: Array,
    },
  },

  data() {
    return {
      number: '',
      bettingSvc : BettingSvc.getBettingSvc(),
      gameSvc: GameSvc.getGameSvc(),
      inputValues: [],
    };
  },

  computed: {
    specialBet() {
      let inputs = 1;
      let type = this.bettingSvc.specialBetType;

      // Number of input fields for these 2 bets is different
      // depending on max number of values received from backend
      // 40 - No draw
      // 41 - All in
      if ([40, 41].indexOf(type) > -1) {
        inputs = Object.keys(this.bettingSvc.specialBets[this.bettingSvc.shortcut].actions).length;
      }

      if (type === 40) {
        if (inputs > sevenConfig.data.config.rules.maxNoDrawNumbers.value) {
          inputs = sevenConfig.data.config.rules.maxNoDrawNumbers.value;
        }
      } else if (type === 41) {
        if (inputs > sevenConfig.data.config.rules.maxAllInNumbers.value) {
          inputs = sevenConfig.data.config.rules.maxAllInNumbers.value;
        }
      }

      return {
        inputs,
      };
    },
    isBettingDisabled () {
      return GameSvc.getGameSvc().gameInfo.betsBlocked;
    }
  },

  mounted() {
    this.clear();
    this.setFocus();
    this.showActions();
    this.listenToEvents();
  },

  destroyed() {
    this.destroyListeners();
  },

  methods: {
    updated(e) {
      if (invalidChars(e)) {
        return;
      }

      setTimeout(() => {
        let value = e.target.value;
        const index = parseInt(e.target.getAttribute('data-index'));

        // certain bets can have only choices from 1-4
        let max = 80;
        const min = 1;

        if (this.bettingSvc.specialBetType !== 40 && this.bettingSvc.specialBetType !== 41) {
          max = this.bettingSvc.actions.length;
        }

        if (/[\d\.]+/i.test(e.target.value)) {
          if (e.target.value > max || e.target.value < min) {
            e.target.value = e.target.value.substring(0, e.target.value.length - 1);
          }
        }

        this.bettingSvc.ticket.input[index] = e.target.value;

        let actions = ['Tab', 'Enter'];
        if (actions.indexOf(e.key) > -1) {
          this.setFocus(index, e.key, e);
        }
      }, 0);
    },

    /**
     * Controls what input field to focus
     *
     * @param [index] {Number|String}
     * @param [action] {String}
     */
    setFocus(index, action, e) {
      if (!index) {
        index = 0;
      }

      const specialBetsForm = document.getElementsByClassName('specialBetsForm')[0];
      const inputs = specialBetsForm.getElementsByTagName('input');
      let input = inputs[index];

      /**
       * Focus inputs in right order
       */
      if (index > this.inputValues.length) {
        index = this.inputValues.length;
        if (index < 0) {
          index = 0;
        }

        input = inputs[index];
        input.focus();
        return;
      }


      if (action) {
        if (!input.value) {
          if (action === 'Tab' || action === 'Enter') {
            if (index) {
              this.focusPayin();
              return;
            }
          }
        } else {
          if (!this.isDuplicate(input.value)) {
            index += 1;
            this.inputValues.push(input.value);
          }
        }
      }

      // On last input, we want to focus payin input field next
      if (index >= inputs.length) {
        this.focusPayin();
      } else {
        const inputToFocus = inputs[index];
        inputToFocus.focus();
      }
    },

    focusPayin() {
      this.bettingSvc.finalizeTicket();
      this.bettingSvc.clearAll();

      EventBus.$emit('keydown', { // rename this
        key: '+'
      });
    },

    clear() {
      this.bettingSvc.ticket.input = [];
      this.inputValues = [];

      const specialBetsForm = document.getElementsByClassName('specialBetsForm')[0];
      const inputs = specialBetsForm.getElementsByTagName('input');

      for (let i = 0; i < inputs.length; i += 1) {
        inputs[i].value = '';
      }
    },

    isDuplicate(num) {
      return this.inputValues.indexOf(num) > -1;
    },

    formatActions() {
      // this.actions is used for displaying inputs above, so we cant
      // work on that array directly
      let ac = cloneDeep(this.actions);

      let splitter = sevenConfig.data.config.rules.maxNoDrawNumbers.value;

      if (this.bettingSvc.specialBetType === 41) {
        splitter = sevenConfig.data.config.rules.maxAllInNumbers.value;
      }

      if ([40, 41].indexOf(this.bettingSvc.specialBetType) > -1) {
        return ac.splice(0, splitter);
      }

      return ac;
    },

    showActions() {
      if (this.actions && this.actions.length) {
        GatewaySvc.getGatewaySvc().showDialog({
            id: 'KenoSpecialBet',
            message: this.name,
            actions: this.formatActions(this.actions),
            showDefaultAction: false,
            focus: false
        });
      }
    },

    listenToEvents() {
      // listen for future bet validation and finalize bet
      EventBus.$on('Keno.FutureBetValid', () => {
        try {
            this.bettingSvc.finalizeTicket();
        } catch (err) {
            return;
        }
        this.resetAll();
      });
    },

    /**
     * Reset betting service and activate normal bet
     */

    resetAll() {
      this.bettingSvc.clearAll();
      EventBus.$emit('keydown',{
          key : '+'
      });
    },

    destroyListeners() {
      EventBus.$off('Keno.FutureBetValid');
    },
  },

  watch: {
    trigger(val, oldVal) {
      if (val !== oldVal) {
        this.setFocus();
        this.clear();
        this.showActions();
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// SpecialBet.vue?c15fbbf4